import { Http, Response, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class CalendarService {

  constructor(private http: Http, private authHttp: AuthHttp) { }

  update(calendar: any) {
    return this.authHttp.post("/api/calendar/", calendar).map(res => res.json());
  }

  getCalendar(groupId: number) {
    return this.authHttp.get("/api/calendar/" + groupId).map(res => res.json());
  }

  getCalendarForGroupByDate(groupId: number, day: number, month: number, year:number){   
    return this.authHttp.get("/api/calendar/bydate/" + groupId+"/"+day+"/"+month+"/"+year).map(res =>{
       return { 'status': res.status, 'value': res.json() }
    });
  }

  getAllCalendars() {
    return this.http.get("/api/calendar").map(res => res.json());
  }

  downloadFile(group: string) {
    return this.http.get(`/api/calendar/downloadFile/${group}`, { responseType: ResponseContentType.Blob }).map((res: Response) => {
      return res;
    });
  }

  downloadExcel() {
    return this.authHttp.get('/api/calendar/generateXlsx', { responseType: ResponseContentType.Blob }).map((res: Response) => {
      return res
    });
  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/calendar.service.ts